import { useSelector } from 'react-redux'
import { GraphType } from 'src/redux/slices/analysis/consts'
import { selectGraphMode } from 'src/redux/slices/analysis/selectors'

import BarCharts from '../components/BarCharts'
import GraphTypeSelector from '../components/GraphTypeSelector'
import SankeyCharts from '../components/SankeyCharts'
import TimeCharts from '../components/TimeCharts'

const GraphsPage: React.FC = () => {
  const graphMode = useSelector(selectGraphMode)
  return (
    <>
      <GraphTypeSelector />
      {graphMode === GraphType.bar && <BarCharts />}
      {graphMode === GraphType.timeSeries && <TimeCharts />}
      {graphMode === GraphType.sankey && <SankeyCharts />}
    </>
    // <Grid container spacing={1} justifyContent="space-between">
    //     <Grid item>
    //     </Grid>
    //     <Grid item xs>

    //     </Grid>

    // </Grid>
  )
}

export default GraphsPage
